import { z } from 'zod'
import { getDuplicatesRefinement } from 'src/util/src/zod'
import { IdSchema } from '../../Generic/models/Id'
import { UrlPatternSchema } from '../../Generic/models/UrlPattern'

export const ReferralSystemSchema = z.object({
  id: IdSchema,
  referralUrlPattern: UrlPatternSchema,
})

export const ReferralSystemsSchema = z.array(ReferralSystemSchema)
  .superRefine(getDuplicatesRefinement('ReferralSystem', parseReferralSystemUid))

export const ReferralSystemUidSchema = ReferralSystemSchema.pick({
  id: true,
})

export type ReferralSystem = z.infer<typeof ReferralSystemSchema>

export type ReferralSystemUid = z.infer<typeof ReferralSystemUidSchema>

export type ReferralSystemId = z.infer<typeof ReferralSystemSchema.shape.id>

export function parseReferralSystem(system: ReferralSystem): ReferralSystem {
  return ReferralSystemSchema.parse(system)
}

export function parseReferralSystems(systems: ReferralSystem[]): ReferralSystem[] {
  return ReferralSystemsSchema.parse(systems)
}

export function parseReferralSystemUid(systemUid: ReferralSystemUid): ReferralSystemUid {
  return ReferralSystemUidSchema.parse(systemUid)
}
